import { icons } from 'PDF/assets/icons';
import { getColorType } from 'PDF/helpers/documentStyle';
import { formatPhonePDF } from 'PDF/helpers/fotmatPhonePDF';

import { IBusinessToolForm } from 'components/BusinessToolForm/utils/form';

export const getLastPageProps = (businessPlanChapters: IBusinessToolForm) => {
  const { companyName, address } = businessPlanChapters.GLOBAL;
  const { file } = businessPlanChapters.OVERVIEW.company;
  const { email, phone, websiteUrl } = businessPlanChapters.ABOUT_COMPANY.generalInfo;
  const { CoverPageAddressIcon, CoverPageMailIcon, CoverPageNameIcon, CoverPagePhoneIcon, CoverPageWebsiteIcon } =
    icons[getColorType()];

  const data = [
    { imgSrc: CoverPageNameIcon, info: companyName },
    { imgSrc: CoverPageMailIcon, info: email },
    { imgSrc: CoverPagePhoneIcon, info: phone ? formatPhonePDF(phone) : undefined },
    { imgSrc: CoverPageWebsiteIcon, info: websiteUrl },
    { imgSrc: CoverPageAddressIcon, info: address },
  ];

  if (!data.length) {
    return {
      logoUrl: file[0]?.url,
      contactData: null,
    };
  }

  const contactData = [[...data.slice(0, 4)], [data[4]]];

  return {
    logoUrl: file[0]?.url,
    contactData,
  };
};
